import { get } from '@core/api/baseApi';
import { AssignRadiologistResponse } from '@core/types';

const getAssignedRadiologists = async (studyInstanceUid: string): Promise<AssignRadiologistResponse> => 
    await get(`/Studies/${studyInstanceUid}/assign-radiologist`);

export default getAssignedRadiologists;
